/* istanbul ignore file */
import React from 'react';

import { PostDialog } from '@lumapps/posts/components/PostDialog';
import { usePostDialog } from '@lumapps/posts/hooks/usePostDialog';
import { DelayedSuspense } from '@lumapps/utils/components/DelayedSuspense';

const LazyComponent = React.lazy(
    () =>
        import(
            /* webpackChunkName: 'article-dialog' */
            './ConnectedArticleDialog'
        ),
);

export const ArticleDialog: React.FC<
    Omit<React.ComponentProps<typeof LazyComponent>, 'openPostDialog'> & { isOpen?: boolean }
> = ({ isOpen, ...props }) => {
    const { isOpen: isPostDialogOpen, createPost: openPostDialog, closePostDialog } = usePostDialog({});

    return (
        <>
            <DelayedSuspense shouldLoad={isOpen}>
                {(setShouldMount) => (
                    <LazyComponent openPostDialog={openPostDialog} onVisibilityChange={setShouldMount} {...props} />
                )}
            </DelayedSuspense>
            <PostDialog isOpen={isPostDialogOpen} closeDialog={closePostDialog} />
        </>
    );
};
